import { useLayoutEffect, useRef, useState } from 'react'

/**
 * Custom hook to determine if the badge content exceeds the container width.
 * @param containerWidth - The width of the container.
 * @param iconLeadingWidth - The width of the leading icon (if any).
 * @param iconTrailingWidth - The width of the trailing icon (if any).
 * @returns An object containing the ref and the state indicating if the badge exceeds the container width.
 */
export const useBadgeWidth = (
  containerWidth?: number,
  iconLeadingWidth?: number,
  iconTrailingWidth?: number
) => {
  const paddings = 16 // px, corresponds to px-2
  const iconGap = 4 // px, corresponds to gap between icon and text
  const totalIconWidth =
    (iconLeadingWidth ?? 0) +
    (iconLeadingWidth ? iconGap : 0) +
    (iconTrailingWidth ?? 0) +
    (iconTrailingWidth ? iconGap : 0)

  const ref = useRef<HTMLDivElement>(null)
  const [badgeGreaterThanContainer, setBadgeGreaterThanContainer] =
    useState(false)

  useLayoutEffect(() => {
    if (containerWidth === undefined) return

    let spanElement: HTMLElement | null = null
    if (
      iconLeadingWidth &&
      ref.current?.children[1]?.children[0]?.tagName === 'SPAN'
    ) {
      spanElement = ref.current.children[1].children[0] as HTMLElement
    } else if (iconLeadingWidth && ref.current?.children[1]) {
      spanElement = ref.current.children[1] as HTMLElement
    } else if (ref.current?.children[0]?.children[0]?.tagName === 'SPAN') {
      spanElement = ref.current.children[0].children[0] as HTMLElement
    } else if (ref.current?.children[0]) {
      spanElement = ref.current.children[0] as HTMLElement
    }

    if (spanElement && containerWidth) {
      const spanWidth = Math.max(
        spanElement.scrollWidth,
        spanElement.offsetWidth
      )

      setBadgeGreaterThanContainer(
        Math.floor(spanWidth + paddings + totalIconWidth) >
          Math.floor(containerWidth ?? 0)
      )
    } /* else if (containerWidth && ref.current) {
      // Fallback to using the badge container width if spanElement is not found
      setBadgeGreaterThanContainer(
        Math.floor(ref.current?.offsetWidth) > Math.floor(containerWidth)
      )
    }*/
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [containerWidth, ref.current?.offsetWidth])

  return { ref, badgeGreaterThanContainer }
}
